import clsx from "clsx"
import { FC, useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import useServerTimer from "hooks/useServerTimer"
import { ServerDate } from "helpers/server-date.class"
import styles from "./index.module.scss"

interface ISaleChestTimer {
  date: string
  onExpire: () => void
}

export const SaleChestTimer: FC<ISaleChestTimer> = ({ date, onExpire }) => {
  const { t } = useTranslation()

  const { hours, minutes, seconds, restart } = useServerTimer({
    expiryTimestamp: new ServerDate(),
    autoStart: false,
    onExpire() {
      onExpire?.()
    }
  })

  const time = useMemo(() => {
    if (!hours && !minutes) return `${seconds}${t("seconds")}`
    if (!hours) return `${minutes}${t("minutes")}`

    return `${hours}${t("hours")}`
  }, [hours, minutes, seconds, t])

  useEffect(() => {
    if (!date) return

    restart(new ServerDate(date))
  }, [date, restart])

  return <div className={clsx(styles.SaleChestTimer)}>{time}</div>
}
